export const NAME = 'auth';
